import { Construction } from 'lucide-react'

interface ComingSoonProps {
  title: string
  description?: string
}

// ComingSoon is a placeholder for features that are planned but not yet
// implemented. It exists so navigation entries do not route to a blank page
// or imply functionality that the backend does not provide.
export default function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {description && <p className="mt-1 text-gray-500">{description}</p>}
      </div>

      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white py-16 text-center">
        <Construction className="h-12 w-12 text-gray-400" />
        <h2 className="mt-4 text-lg font-medium text-gray-900">Not implemented yet</h2>
        <p className="mt-2 max-w-md text-sm text-gray-500">
          This section is planned but not yet available. No backend endpoints
          are wired for it, so nothing is being managed here.
        </p>
      </div>
    </div>
  )
}
